import styled from 'styled-components';
import { NeutralColors } from 'theme';

const LoadingState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 16px;
  color: ${NeutralColors[60]};
  font-size: 14px;
`;

export { LoadingState };
